<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka" />
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Pošlji SMS
          </p>
        </div>
        <div style="padding-top: 20px">
          <el-tabs type="border-card" class="velikost-el-tabs" @tab-click="HandleTabClick" value="t1">
            <el-tab-pane label="SMS Pošiljatelj" name="t1" ref="t1">
              <div v-if="activetab === 't1'">
                <PosljiSmsVmesnik
                        :listaZacetnihSt="listaZacetnihSt"
                        :selectedContacts="selectedContacts"
                        :vsiKontakti="vsiKontakti"
                        :izbranPosiljatelj="izbranPosiljatelj"
                        :listaPosiljatelji="listaPosiljatelji"
                        :clientAgent="clientAgent"
                        :smsAuthentication="smsAuthentication"
                        :smsLimit="smsLimit"
                        v-on:mfaIzklopljen="opozoriloIzklopljenMfa"
                        v-on:updateIzbranPosiljatelj="OnUpdateIzbranPosiljatelj"
                        v-on:updateSmsLimit="OnupdateSmsLimit"
                        v-on:updateSelectedContacts="OnUpdateSelectedContacts"/>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Imenik oseb" name="t2" ref="t2">
              <div v-if="activetab === 't2'">
                <ImenikOseb
                        :listaZacetnihSt="listaZacetnihSt"
                        :izbranPosiljatelj="izbranPosiljatelj"
                        :vsiKontakti="vsiKontakti"
                        :vseSkupine="vseSkupine"
                        :clientAgent="clientAgent"
                        :selectedContacts="selectedContacts"
                        :smsAuthentication="smsAuthentication"
                        :smsLimit="smsLimit"
                        v-on:mfaIzklopljen="opozoriloIzklopljenMfa"
                        v-on:updateSelectedContacts="OnUpdateSelectedContacts"
                        v-on:updateKontakt="OnUpdateContact"
                        v-on:updateGroups="OnUpdateGroups"/>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Imenik skupin" name="t3" ref="t3">
              <div v-if="activetab === 't3'">
                <ImenikSkupin
                        :izbranPosiljatelj="izbranPosiljatelj"
                        :vseSkupine="vseSkupine"
                        :vsiKontakti="vsiKontakti"
                        :clientAgent="clientAgent"
                        :selectedContacts="selectedContacts"
                        :smsAuthentication="smsAuthentication"
                        v-on:mfaIzklopljen="opozoriloIzklopljenMfa"
                        v-on:selectGroup="OnUpdateSelectedContacts"
                        v-on:updateKontakt="OnUpdateContact"
                        v-on:updateGroups="GetPridobiVseSkupine"/>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Button, CollapseItem, Collapse, Input, Tabs, TabPane, Select, Table,
  Option, Dialog, Notification, MessageBox
} from 'element-ui'
import ImenikOseb from './PosljiSms/ImenikOseb'
import ImenikSkupin from './PosljiSms/ImenikSkupin'
import PosljiSmsVmesnik from './PosljiSms/PosljiSmsVmesnik'
import ClientAgent from '../../../../assets/js/clientAgent'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {GetPodatkiIzbirnika} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika'
import {configSSO} from '../../../../assets/js/config'
import {PridobiStranko} from '../../../../assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import {ZacetneStevilkeUmtsEnum} from '../../../../assets/js/Enum/ZacetneStevilkeUmtsEnum'
import Vue from 'vue'

export default {
  name: 'PosljiSms',
  mixins: [GetPodatkiIzbirnika, PridobiStranko],
  components: {
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    'IzbirnikStranke': IzbirnikStranke,
    [Button.name]: Button,
    [Input.name]: Input,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Table.name]: Table,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Notification.name]: Notification,
    'ImenikOseb': ImenikOseb,
    'ImenikSkupin': ImenikSkupin,
    'PosljiSmsVmesnik': PosljiSmsVmesnik
  },
  data () {
    return {
      activetab: 't1',
      idPrikljucek: null,
      izbranaZacetnaStVDialogu: '064',
      vsiKontakti: [],
      vseSkupine: [],
      lengthOfSezPrejemnikov: 0,
      selectedContacts: [],
      selectedGroups: [],
      copySkupineKontakta: [],
      listaZacetnihSt: ZacetneStevilkeUmtsEnum,
      clientAgent: null,
      listaPosiljatelji: [],
      izbranPosiljatelj: null,
      smsLimit: 0,
      smsAuthentication: false
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetUserData()
  },
  watch: {
    izbranPosiljatelj: function (posiljatelj) {
      if (posiljatelj !== null) {
        this.GetPridobiVseKontakte()
        this.GetPridobiVseSkupine()
        this.GetLimitPosiljanjaSms()
      }
    }
  },
  methods: {
    GetLimitPosiljanjaSms () {
      let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/sms/pridobiLimit?',
        param,
        null,
        'SetLimitPosiljanjaSms',
        '')
    },
    SetLimitPosiljanjaSms (podatki) {
      this.smsLimit = 0
      this.smsLimit = podatki.data.omejitev
    },
    PrenosniPodatkiStranka (osebnikPodatki) {
      this.smsAuthentication = osebnikPodatki.smsTokenLogin
    },
    opozoriloIzklopljenMfa () {
      MessageBox.confirm(
        'Za pošiljanje SMS sporočil je potrebno vklopiti dvostopenjsko zaščito računa.<br>', {
          html: true,
          confirmButtonText: 'VKLOPI ZAŠČITO',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog',
          dangerouslyUseHTMLString: true
        }).then(() => {
        let redirectUrl = new URL(configSSO.AUTH0_CALLBACK_URL)
        let baseUrl = 'https://' + configSSO.AUTH0_DOMAIN + '/?'
        baseUrl += 'redirect_uri=' + redirectUrl.origin + '/Mojprofil/Varnost'
        window.location = baseUrl
      }).catch((err) => {
        err = null
      })
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStrankaSap = podatkiStranke.id_stranka_sap
        this.GetTelSt()
        this.selectedContacts = []
      }
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
    },
    OnUpdateContact () {
      this.GetPridobiVseKontakte()
    },
    OnUpdateSelectedContacts (contactList, overrideList = false) {
      if (!overrideList) {
        let newContacts = []
        for (let i = 0; i < contactList.length; i++) {
          if (!this.selectedContacts.find(x => x.mobile === contactList[i].mobile)) {
            if (typeof contactList[i].contacts !== 'undefined') {
              for (let j = 0; j < contactList[i].contacts.length; j++) {
                Vue.set(contactList[i].contacts[j], 'group', contactList[i].naziv)
                newContacts.push(JSON.parse(JSON.stringify(contactList[i].contacts[j])))
              }
            } else {
              newContacts.push(JSON.parse(JSON.stringify(contactList[i])))
            }
          }
        }
        this.selectedContacts = this.selectedContacts.concat(newContacts)
      } else {
        this.selectedContacts = contactList
      }
    },
    OnUpdateGroups () {
      this.GetPridobiVseSkupine()
    },
    OnupdateSmsLimit (velikostSmsLimita) {
      this.velikostLimita = 0
      this.velikostLimita = velikostSmsLimita
    },
    OnUpdateIzbranPosiljatelj (posiljatelj) {
      this.izbranPosiljatelj = posiljatelj
    },
    GetTelSt () {
      this.loading = true
      let param = ['permissionId=SMS_POSILJANJE']
      // let param = ['permissionId=PORABA_TELEFONIJA']
      param.push('filter[sap]=' + this.izbranaStrankaSap)
      let errorMessage = 'Napaka pri pridobivanju telefonske številke.'
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission?',
        param,
        errorMessage,
        'SetTelStZsSap',
        'SendError')
    },
    SetTelStZsSap (podatki) {
      let tmpLista = []
      let telefonske = podatki.permission.additionalData
      for (let i = 0; i < telefonske.length; i++) {
        tmpLista.push(telefonske[i])
      }
      if (tmpLista.length > 0) {
        this.izbranPosiljatelj = tmpLista[0]
        this.idPrikljucek = tmpLista[0].id_prikljucek
      }
      this.listaPosiljatelji = tmpLista
      this.loading = false
    },
    GetPridobiVseKontakte () {
      if (this.izbranPosiljatelj === null) {
        return false
      }
      let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
      let errorMessage = 'Napaka pri pridobivanju kontaktov.'
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/sms/imenik/pridobiKontakte?',
        param,
        errorMessage,
        'SetPridobiVseKontakte',
        'ShowError')
    },
    SetPridobiVseKontakte (podatki) {
      this.vsiKontakti = podatki.data
    },
    GetPridobiVseSkupine () {
      if (this.izbranPosiljatelj === null) {
        return false
      }
      let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
      let errorMessage = 'Napaka pri pridobivanju skupin kontaktov.'
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/sms/imenik/pridobiSkupine?',
        param,
        errorMessage,
        'SetPridobiVseSkupine',
        'ShowError')
    },
    SetPridobiVseSkupine (podatki) {
      this.vseSkupine = podatki.data
    },
    SelectGroup (selectedGroup) {
      for (let i = 0; i < selectedGroup.contacts.length; i++) {
        if (this.selectedContacts.length < this.velikostLimita) {
          this.OnSelectContact(selectedGroup.contacts[i])
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Dodanih je lahko največ' + this.velikostLimita + 'prejemnikov'
          this.ShowWarningMessage(paramObvestilo)
          break
        }
      }
    },
    OnSelectContact (selectedContact) {
      if (this.selectedContacts.length < this.velikostLimita) {
        if (this.selectedContacts.length > 0) {
          let findContact = this.selectedContacts.find(x => x.idAddressBook === selectedContact.idAddressBook)
          if (findContact === undefined) {
            this.selectedContacts.push(selectedContact)
          } else {
            let findId = this.selectedContacts.indexOf(selectedContact)
            if (findId !== -1) {
              this.selectedContacts.splice(findId, 1)
            }
          }
        } else {
          this.selectedContacts.push(selectedContact)
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Dodanih je lahko največ' + this.velikostLimita + 'prejemnikov'
        this.ShowWarningMessage(paramObvestilo)
      }
      this.CheckGroupsIfSelected(this.selectedContacts)
      this.lengthOfSezPrejemnikov = this.selectedContacts.length
    },
    CheckGroupsIfSelected (val) {
      if (val.length !== 0) {
        let checkedGroups = []
        if (typeof this.vseSkupine.groups !== 'undefined') {
          for (let i = 0; i < this.vseSkupine.groups.length; i++) {
            let checkCount = 0
            for (let j = 0; j < this.vseSkupine.groups[i].contacts.length; j++) {
              for (let k = 0; k < val.length; k++) {
                if (val[k].idAddressBook === this.vseSkupine.groups[i].contacts[j].idAddressBook) {
                  checkCount = checkCount + 1
                }
              }
            }
            if (checkCount === this.vseSkupine.groups[i].contacts.length) {
              let findArrId = checkedGroups.find(x => x === this.vseSkupine.groups[i])
              if (findArrId === undefined) {
                checkedGroups.push(this.vseSkupine.groups[i])
              }
            } else {
              checkedGroups.splice(this.vseSkupine.groups[i], 1)
            }
          }
        }
        for (let k = 0; k < checkedGroups.length; k++) {
          this.selectedGroups.push(checkedGroups[k])
        }
      }
    },
    OdstraniKontaktIzImenika (contact) {
      this.objetOsebaUrejanjePodakov = contact
      this.IzbirsiKontakt()
    },
    OdstraniPrejemnikaIzSeznama (contact) {
      for (let i = 0; i < this.selectedContacts.length; i++) {
        if (this.selectedContacts[i].mobile === contact.mobile) {
          this.selectedContacts.splice(i, 1)
          let findIndex = this.selectedContacts.indexOf(contact.idAddressBook)
          this.selectedContacts.splice(findIndex, 1)
          this.lengthOfSezPrejemnikov = this.selectedContacts.length
          return
        }
      }
    },
    UrediKontakt (contact) {
      for (let i = 0; i < this.vsiKontakti.length; i++) {
        if (this.vsiKontakti[i].idAddressBook === contact.idAddressBook) {
          this.objetOsebaUrejanjePodakov = JSON.parse(JSON.stringify(this.vsiKontakti[i]))
          this.objetOsebaUrejanjePodakov.mobile = this.vsiKontakti[i].mobile.slice(3, 9)
          break
        }
      }
      this.skupineKontakta = []
      for (let j = 0; j < this.vseSkupine.groups.length; j++) {
        let check = 0
        for (let k = 0; k < this.vseSkupine.groups[j].contacts.length; k++) {
          if (this.vseSkupine.groups[j].contacts[k].idAddressBook === this.objetOsebaUrejanjePodakov.idAddressBook) {
            check = check + 1
            break
          }
        }
        if (check === 1) {
          this.skupineKontakta.push(this.vseSkupine.groups[j])
        }
      }
      this.copySkupineKontakta = JSON.parse(JSON.stringify(this.skupineKontakta))
    }
  }
}
</script>
<style scoped src="../../../../../static/css/UporabniskiKoticek/PosljiSms/PosljiSms.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/PosljiSms.vue